module.exports = __webpack_public_path__ + "static/media/icon-gc-lite.6e9711ac.svg";